export const NOT_APPLICABLE = 'N/A';
export const DAY_RANGE = 6;
export const LOAD_METRICS_DEBOUNCE_TIME = 100;
export const DECIMAL_PLACES = 2;
export const DST_AFFECTED_HOUR = 23;
export const HOUR_ADJUSTMENT = 1;
export const MINUTES_IN_HOUR = 60;
// Constants for chart bucket auto-selection based on date range
export const MILLISECONDS_MULTIPLIER = 1000;
export const WEEK_BUCKET_THRESHOLD_DAYS = 60;
export const MONTH_BUCKET_THRESHOLD_DAYS = 300;

